import borders from "../../base/borders";
import boxShadows from "../../base/boxShadows";
import colors from "../../base/colors";

const { borderRadius } = borders;
const { background, divider } = colors;

/** Fluent dialog: 8px corners, layered surface and a lightly blurred scrim. */
const dialog = {
  styleOverrides: {
    root: {
      "& .MuiBackdrop-root:not(.MuiBackdrop-invisible)": {
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        backdropFilter: "blur(4px)",
      },
    },

    paper: {
      borderRadius: borderRadius.lg,
      boxShadow: boxShadows.xxl,
      backgroundColor: background.paper,
      backgroundImage: "none",
      border: `1px solid ${divider}`,
    },

    paperFullScreen: {
      borderRadius: 0,
      border: "none",
    },
  },
};

export default dialog;
